<div class="page-layout carded fullwidth" >
  <mat-drawer-container class="overlay-container"  autosize>

    <filtros [(filtro)]="filterForm" (loadData)="loadData()"  (filterChange)="filterForm=$event"></filtros>

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{titulo}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8">
                <span>Evaluaciones</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" fxFlex="100" fxLayout="column">

              <table mat-table [dataSource]="dataSource" #mytablePreiniciado class="my-table mat-elevation-z8" fxFlex="100">

                <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

                <!-- User Column -->
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef> Nombre </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                </ng-container>

                <ng-container matColumnDef="version">
                  <th mat-header-cell *matHeaderCellDef> Versión </th>
                  <td mat-cell *matCellDef="let element"> {{element.version}} </td>
                </ng-container>

                <ng-container matColumnDef="estructuraJerarquica">
                  <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
                  <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
                </ng-container>

                <ng-container matColumnDef="creador">
                  <th mat-header-cell *matHeaderCellDef> Creador </th>
                  <td mat-cell *matCellDef="let element"> {{element.creador?.nombreCompleto}} </td>
                </ng-container>

                <ng-container matColumnDef="responsable">
                  <th mat-header-cell *matHeaderCellDef> Responsable </th>
                  <td mat-cell *matCellDef="let element"> {{element.responsable?.nombreCompleto}} </td>
                </ng-container>

                <ng-container matColumnDef="fechaInicio">
                  <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="fechaFin">
                  <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Acción </th>
                  <td mat-cell *matCellDef="let element" class="action-link">
                    <a  (click)="navegateTo('/consolidacion',element.id)" *ngIf="element.tieneEditar">Ver</a>
                    <!--<span *ngIf="element.tieneEditar">|</span>
                    <a *ngIf="element.tieneEditar" (click)="navegateTo('/consolidacion',element.id)" >Editar</a>-->
                    <span *ngIf="element.tieneEliminar"> | </span>
                    <a *ngIf="element.tieneEliminar" (click)="openDialog('Delete',element)">Eliminar</a>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
            (page)="OnePageChange($event)" showFirstLastButtons fxFlex="100"></mat-paginator>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->
    </mat-drawer-container>
</div>
